export const navigationPaneScreenReaderOnlyText = "gac";
export default {navigationPaneScreenReaderOnlyText};